<ngx-spinner
  type="ball-scale-multiple"
  [color]="spinnerColor"
  [fullScreen]="true"></ngx-spinner>
<router-outlet></router-outlet>
